const React = require("react");
const bugsnag = require('@bugsnag/js');
const env = require('services/env');

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {hasError: false};

        const bugsnag_key = env.get('bugsnag.key', null);
        const notify_stages = env.get('bugsnag.notify_stages', []).filter(e => !!e);
        const current_stage = env.get('environment');

        if (bugsnag_key !== null && notify_stages.indexOf(current_stage) > -1) {

            this.bugsnag_client = bugsnag({
                apiKey: bugsnag_key,
                user: env.get('user'),
            });
        }

    }

    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return {hasError: true};
    }

    componentDidCatch(error, info) {
        // You can also log the error to an error reporting service
        console.error('Cought error', error, info);
        //logErrorToMyService(error, info);
        if (this.bugsnag_client) {
            console.log('notifying error');
            this.bugsnag_client.notify(error, info);
        }
    }

    render() {
        if (this.state.hasError) {
            // You can render any custom fallback UI
            return <p className="red" >Der opstod en fejl</p >;
        }

        return (
            <React.Fragment>
                {this.props.children}
            </React.Fragment>
        );
    }
}

module.exports = ErrorBoundary;
